import Head from "next/head";
import React from "react";

import PersonalInfoFormMain from "@/components/generic/personal-info-form-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const PersonalInfoFormPage = () => {
  return (
    <>
      <Head>
        <title>{seoData.PERSONAL_INFO_FORM.title}</title>
        <SeoMetaData data={seoData.PERSONAL_INFO_FORM} />
      </Head>

      <PersonalInfoFormMain />
    </>
  );
};

export default PersonalInfoFormPage;
